import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SynSplashScreenService {
  public readonly isLoaderVisibleSignal = signal<boolean>(false);

  show(): void {
    this.isLoaderVisibleSignal.set(true);
  }

  hide(): void {
    this.isLoaderVisibleSignal.set(false);
  }
}
